module.exports = {
          srcSet: __webpack_public_path__ + "c842e6c69378107436d5c3aa6a6c659d-1918.png"+" 1918w",
          images:[ {path: __webpack_public_path__ + "c842e6c69378107436d5c3aa6a6c659d-1918.png",width: 1918,height: 1079}],
          src: __webpack_public_path__ + "c842e6c69378107436d5c3aa6a6c659d-1918.png",
          toString:function(){return __webpack_public_path__ + "c842e6c69378107436d5c3aa6a6c659d-1918.png"},
          
          width: 1918,
          height: 1079
        }